module.exports = __webpack_public_path__ + "img/thumb3.98f18af1.png";